import CredentialsInput from './CredentialsInput.vue';

export default CredentialsInput;
